module.exports = __webpack_public_path__ + "static/media/simulator-icon.fdbd4553.jpeg";